import IssueDetails from '../issue-details'

export default function Interior({ issues }) {
  return (
    <div className='issueSectionWrapper'>
      {issues.map((issue) => (
        <div className='line flex justifyBetween' key={issue.description}>
          <div className='item flex'>
            <IssueDetails {...issue} />
          </div>
        </div>
      ))}
    </div>
  )
}
